import { render, staticRenderFns } from "./FullscreenImage.vue?vue&type=template&id=12977250&"
import script from "./FullscreenImage.vue?vue&type=script&lang=js&"
export * from "./FullscreenImage.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenImage.vue?vue&type=style&index=0&id=12977250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports